import { Switch, FormControlLabel, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";
import _ from "lodash";

const CustomSwitch = ({
  name,
  label,
  form: { control, formState },
  required,
  size,
  ...props
}) => (
  <>
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          rules={{
            required,
          }}
          render={({ field }) => (
            <Switch
              {...field}
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              {...props}
            />
          )}
        />
      }
      label={label}
      sx={{
        width: "fit-content",
        "& .MuiFormControlLabel-label": {
          fontSize: size,
          fontWeight: 600,
        },
      }}
    />
  </>
);

export default CustomSwitch;
